import { useEffect } from "react";

/** Lớp đánh dấu trên `<html>`; luật CSS đi kèm nằm trong `theme.css`. */
export const PAGE_SCROLL_LOCK_CLASS = "app-shell-scroll-lock";

/**
 * Khoá cuộn của TRANG trong lúc khung ứng dụng đang mở (#19629).
 *
 * <p>`AppShell` dựng một khung cao đúng một màn hình (`h-screen overflow-hidden`): phần nội dung
 * cuộn trong `<main>`, menu cuộn trong cột của nó. Nhưng `html`/`body` thì chưa bao giờ bị ghim,
 * nên chỉ cần một thứ gì đó làm trang cao hơn khung nhìn — một lớp phủ dựng qua portal, một thanh
 * cuộn ngang, một `scrollIntoView({block:"nearest"})` của ô chọn ở đâu đó — là cả trang cuộn được.
 * Và khi nó cuộn thì **mọi thứ đi cùng**: logo, thanh trên và cả cột menu trôi lên, rồi trôi về.
 *
 * <p>Đó chính là thứ QA quay được ở màn Lịch hẹn: menu bên trái "nhảy" giữa hai vị trí trong khi
 * người dùng không cuộn gì. Xem từng khung hình của video thì thấy không phải menu tự cuộn — cả
 * trang dịch lên khoảng 55px (logo và thanh tìm kiếm biến mất, đáy trang hở ra một mảng trắng),
 * rồi dịch về.
 *
 * <p>Chữa ở gốc: trong lúc khung ứng dụng còn trên màn hình thì trang không cuộn được, đúng điều
 * khung ấy vốn đã giả định. Gỡ lớp khi rời đi vì các trang NGOÀI khung (`/site/:slug`, trang đăng
 * nhập) cuộn bằng chính trang và phải giữ nguyên như vậy.
 */
export function usePageScrollLock(): void {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add(PAGE_SCROLL_LOCK_CLASS);
    return () => {
      root.classList.remove(PAGE_SCROLL_LOCK_CLASS);
    };
  }, []);
}
